<div class="p-fluid">
  <textarea
    *ngIf="!isDisplayTable"
    class="paste-textarea"
    style="white-space: pre;"
    pInputTextarea
    (paste)="handlePaste($event)"
    (ngModelChange)="onChangeText($event)"
    [(ngModel)]="pastedText"
    placeholder="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PasteHereText' | translate}}"
  ></textarea>
</div>

<p-table 
  *ngIf="rows.length && isDisplayTable" [value]="rows"
  styleClass="p-datatable-sm p-datatable-gridlines"
  responsiveLayout="stack"
  [breakpoint]="'45vh'"
  [scrollable]="true"
  [resizableColumns]="true"
  columnResizeMode="expand"
  scrollHeight="45vh"
  class="paste-data-table"
>
  <ng-template pTemplate="body" let-row>
    <tr>
      <td *ngFor="let col of headers">{{ row[col] }}</td>
    </tr>
  </ng-template>
</p-table>